import DashboardLayout from "../components/layouts/DashboardLayout/DashboardLayout";

export default function DocumentsPage() {

    return (

        <DashboardLayout
            pageTitle="Documents"
        >

            <div style={{ padding: "30px" }}>

                <h1>Mes documents</h1>

                <p>

                    Cette page sera développée prochainement.

                </p>

            </div>

        </DashboardLayout>

    );

}